import fetch from '@/plugin/axios'

// 用户证书列表(总表)
export function userCerts (query) {
  return fetch({
    url: '/api/member/user-cert/user-certs',
    method: 'Post',
    data: query
  })
}

// 获取基础属性
export function getAttrBase (query) {
  return fetch({
    url: '/api/member/user-cert/attr/base',
    method: 'Get',
    params: query
  })
}

// 扣除基础属性
export function getBaseSet (query) {
  return fetch({
    url: '/api/member/user-cert/attr/base/set',
    method: 'Post',
    data: query
  })
}

// 属性审核列表
export function getAttrList (query) {
  return fetch({
    url: '/api/member/user-attr-inform/list',
    method: 'Post',
    data: query
  })
}

// 影响力审核
export function getAttrAudit (query) {
  return fetch({
    url: '/api/member/user-attr-inform/audit',
    method: 'Post',
    data: query
  })
}
